import React from 'react'
import { useTranslation } from 'react-i18next'

import { HouseholdServing, ScaledRecipe } from '@/api/types'
import { Grid } from '@/components/Grid'
import { getNutrientsForUser, getRecipeQuantity } from '../../utils'
import SoupIcon from '@/features/Icons/SoupIcon'

function HouseholdMemberRow({
  householdServing,
  scaledRecipe,
}: {
  householdServing: HouseholdServing
  scaledRecipe: ScaledRecipe
}) {
  const memberPortionEnergy = getNutrientsForUser(
    [scaledRecipe],
    householdServing.user.idUser,
  ).energy
  const memberPortionQty = getRecipeQuantity(scaledRecipe, householdServing.user.idUser)

  return (
    <>
      <div className="HouseholdMeals-user">
        <div style={{ textAlign: 'left', display: 'flex', gap: '5px' }}>
          {householdServing.user.firstName || 'Main User'}
        </div>
        <div style={{ textAlign: 'end', paddingRight: '10px' }}>
          {householdServing.portionInServings} <SoupIcon />
        </div>
      </div>
      <div>{Math.round(memberPortionQty)}</div>
      <div>{Math.round(memberPortionEnergy)}</div>
    </>
  )
}

export default function HouseholdMeals({ scaledRecipe }: { scaledRecipe: ScaledRecipe }) {
  const { t } = useTranslation()

  return (
    <div className="HouseholdMeals">
      <Grid className="MealDetail-gridHeader" columns="9fr 2fr 1fr" gap={0}>
        <div className="">{t('recipe.servings')}</div>
        <div>Grams</div>
        <div>Kcal</div>
      </Grid>

      <Grid className="MealDetail-grid" columns="9fr 2fr 1fr" gap={0}>
        {scaledRecipe.householdServings &&
          scaledRecipe.householdServings.map((hs, i) => (
            <HouseholdMemberRow key={i} householdServing={hs} scaledRecipe={scaledRecipe} />
          ))}
      </Grid>
    </div>
  )
}
